import PropTypes from 'prop-types';
// @mui
import { Paper, Typography } from '@mui/material';
// locales
import { useLocales } from '../../locales';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  query: PropTypes.string,
  sx: PropTypes.object,
};

export default function SearchNotFound({ query, sx, ...other }) {
  const { translate } = useLocales();

  return query ? (
    <Paper
      sx={{
        textAlign: 'center',
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h6" paragraph>
        {translate('GENERAL.NOT_FOUND')}
      </Typography>

      <Typography variant="body2">
        {translate('GENERAL.NO_RESULTS_FOUND_FOR')}
        <br />
        <strong>&quot;{query}&quot;</strong>.
        <br />
        {translate('GENERAL.TRY_CHECKING_TYPOS')}
      </Typography>
    </Paper>
  ) : (
    <Typography variant="body2" sx={sx}>
      {translate('GENERAL.PLEASE_ENTER_KEYWORDS')}
    </Typography>
  );
}
